import { LoadingOutlined } from '@ant-design/icons'
import { Button as AntButton, ConfigProvider, Spin } from 'antd'
import * as React from 'react'

import { arrayOf, bool, func, node, oneOf, oneOfType, string } from 'prop-types'
const antLoaderIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />

export const Button = ({ loading, children, icon, color, className, size, ...props }) => {

  let classNames = ''
  switch (size) {
    case 'none':
      classNames = ' '
      break
    case 'xs':
      classNames = ' py-1 px-2 text-sm rounded-lg'
      break
    case 'lg':
      classNames = ' py-3 px-6 fs-lg font-medium rounded-md '
      break
    case 'xl':
      classNames = ' py-4 px-8 fs-xl font-medium rounded-lg '
      break
    default: // md
      classNames = 'py-3 px-4 text-lg rounded-xl font-semibold'
      break
  }

  switch (color) {
    case 'purple':
      classNames += ` 
       bg-slate-500/[.5]
       backdrop-blur-md 
        hover:bg-violet-600 
        active:bg-violet-700 
        focus:outline-none 

    
        text-white 
        hover:text-white 
        focus:text-white 
      `
      break

  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#633EBA',
          // colorPrimaryHover: '#5435a1',
        },
      }}
    >
      <AntButton
        key={size}
        loading={loading}
        className={`
        h-max 
        active:scale-95 
        ${classNames} 
        ${className || ''}
      `}
        {...props}
      >
        {children}
        {loading && <Spin indicator={antLoaderIcon} />}
      </AntButton>
    </ConfigProvider>
  )
}

Button.propTypes = {
  size: oneOf(['none', 'xs', 'md', 'lg', 'xl']),
  color: oneOf(['primary', 'secondary', 'accent', 'danger', 'grey', 'ghost', 'gradient']),
  loading: bool,
  disabled: bool,
  className: string,
  onClick: func,
  children: oneOfType([
    arrayOf(node), node
  ])
}

Button.defaultProps = {
  size: 'lg',
  color: 'primary',
  loading: false,
  disabled: false,
}
